import i18n from '../i18n/i18n';
const { t } = i18n.global;

export const invoicePeriodOptions = [
  {
    label: t('filter.periodOptions.AllTime'),
    value: 'all_time',
  },
  {
    label: t('filter.periodOptions.ThisMonth'),
    value: 'this_month',
  },
  {
    label: t('filter.periodOptions.PreviousMonth'),
    value: 'previous_month',
  },
  {
    label: t('filter.periodOptions.Quarter'),
    value: 'quarter',
  },
  {
    label: t('filter.periodOptions.YearToDate'),
    value: 'year_to_date',
  },
  {
    label: t('filter.periodOptions.Custom'),
    value: 'custom',
  },
];

export const periodOptions = [
  {
    label: t('filter.periodOptions.ThisMonth'),
    value: 'this_month',
  },
  {
    label: t('filter.periodOptions.PreviousMonth'),
    value: 'previous_month',
  },
  {
    label: t('filter.periodOptions.Quarter'),
    value: 'quarter',
  },
  {
    label: t('filter.periodOptions.YearToDate'),
    value: 'year_to_date',
  },
  {
    label: t('filter.periodOptions.Custom'),
    value: 'custom',
  },
];
